import styled from 'styled-components';

export const List = styled.div`
  display: flex;
  flex-flow: column;
  gap: 12px;
  width: 100%;
`;

export default List;
